module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABM0lEQVQ4ja3Tuy9EURTF4W9EJ2iQTKtAp6HTUA+NRE8vHqWMSIxEJUQ0U/APoPGoFZQSjUKlnURUHg3FKO6+yWQcDLGSnZXsu+7v7puzT6FarUqoB8soYSB6dzjBLh7zYK1WA+0JyDT20d3UH45awByOGx+2JSCHATnDBDqjJqLXFZnpr0C9OEABa5jEBV6iLqK3GpkD9KVA8/G1c6wnfjnXBk4ju5gCTYVvfQPJtR1eSoGGwq9bAOWZwRToN6qHv6VAd+EjLYBGw+9ToJPwpRZAeeY8BdrDk+yIy99AypF5wk4K9CDb2DoqsiMeR0fUeExdicxcvIPPV+QYM7JlK2k43gY9Y9YPVwSO0I9N3OIdr7iRLWN/MyQ1Ua5HrES1pL/u0Se14xJjfwUUi0W4+q+JCh89IT4HCT7R4AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/common/images/pp35.png
// module id = aruk
// module chunks = 22